var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container-sitc" }, [
    _c("div", { staticClass: "filter-container-content" }, [
      _c("div", { staticStyle: { padding: "0 40px" } }, [
        _c("span", { staticClass: "title-h4" }, [
          _vm._v(_vm._s(_vm.$t("tariffs.title"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", [
            _c(
              "a",
              {
                staticClass: "div-size",
                attrs: { href: _vm.outboundFile, target: "_blank" },
              },
              [_vm._v(_vm._s(_vm.$t("tariffs.outboundDEM")))]
            ),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "div-size",
                attrs: { href: _vm.inboundFile, target: "_blank" },
              },
              [_vm._v(_vm._s(_vm.$t("tariffs.inboundDEM")))]
            ),
            _c("br"),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("tariffs.tips_1")))]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }